// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChatLayout.css - ChatGPT-style layout system */

/* Global scrollbar reset to prevent other styles from overriding */
*::-webkit-scrollbar-track {
  all: unset;
}

.chat-layout {
  display: flex;
  flex: 1 1 auto;
  min-height: 0; /* allow flex child to shrink and enable internal scrolling */
  width: 100%;
  overflow: hidden;
  background-color: white;
}

.dark .chat-layout {
  background-color: #1f2937;
}

/* Sidebar area */
.chat-sidebar {
  flex-shrink: 0;
  height: 100%;
  min-height: 100%;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #F3F6FC;
  transition: all 0.3s ease;
  width: 260px;
  overflow-y: auto;
  z-index: 20;
  display: flex;
  flex-direction: column;
}

/* Custom scrollbar for sidebar */
.chat-sidebar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.chat-sidebar::-webkit-scrollbar-track,
.custom-scrollbar::-webkit-scrollbar-track {
  background: #F3F6FC !important;
  box-shadow: none !important;
  border: none !important;
}

.chat-sidebar::-webkit-scrollbar-thumb {
  background: rgba(115, 115, 115, 0.5);
  border-radius: 3px;
}

.chat-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(100, 100, 100, 0.7);
}

.chat-sidebar-hidden {
  width: 0;
  max-width: 0;
  overflow: hidden;
}

.dark .chat-sidebar {
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  background-color: #202123;
}

.dark .chat-sidebar::-webkit-scrollbar-track,
.dark .custom-scrollbar::-webkit-scrollbar-track {
  background: #202123 !important;
}

.dark .chat-sidebar::-webkit-scrollbar-thumb {
  background: rgba(217, 217, 227, 0.2);
}

.dark .chat-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(217, 217, 227, 0.3);
}

/* Main content area - this is the container for messages AND input */
.chat-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  background-color: white;
  transition: all 0.3s ease;
  max-width: calc(100% - 260px);
  width: 100%;
}

.chat-sidebar-hidden + .chat-content {
  max-width: 100%;
}

.dark .chat-content {
  background-color: #343541;
}

/* Messages container - scrollable area between header and input */
.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding-top: 56px; /* Reserve space for conversation header */
  padding-bottom: 130px; /* Space for input area */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch; /* Smoother scrolling on iOS */
  background: linear-gradient(to bottom, transparent 0%, transparent 95%, rgba(255, 255, 255, 0) 100%);
}

/* Custom scrollbar for messages */
.chat-messages::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.chat-messages::-webkit-scrollbar-track {
  background: white;
}

.chat-messages::-webkit-scrollbar-thumb {
  background: rgba(115, 115, 115, 0.5);
  border-radius: 3px;
}

.chat-messages::-webkit-scrollbar-thumb:hover {
  background: rgba(100, 100, 100, 0.7);
}

.dark .chat-messages {
  background: linear-gradient(to bottom, transparent 0%, transparent 95%, rgba(31, 41, 55, 0) 100%);
}

.dark .chat-messages::-webkit-scrollbar-track {
  background: #343541;
}

.dark .chat-messages::-webkit-scrollbar-thumb {
  background: rgba(217, 217, 227, 0.2);
}

.dark .chat-messages::-webkit-scrollbar-thumb:hover {
  background: rgba(217, 217, 227, 0.3);
}

/* Input area at bottom - always within chat-content */
.chat-input-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 8px 0;
  background-color: white;
  padding-bottom: env(safe-area-inset-bottom, 0);
  padding-bottom: constant(safe-area-inset-bottom, 0);
  z-index: 10;
}

.dark .chat-input-container {
  background-color: #343541;
}

/* For Android devices, add extra padding at the bottom when in mobile viewport */
@supports (-webkit-touch-callout: none) {
  .chat-input-container {
    padding-bottom: calc(env(safe-area-inset-bottom, 16px) + 16px);
  }
}

/* Specific Android system navigation bar handling */
.android-nav-present .chat-input-container {
  padding-bottom: calc(env(safe-area-inset-bottom, 16px) + 48px);
}

/* Mobile-specific styles */
@media (max-width: 767px) {
  /* Sticky chat header for mobile */
  .chat-header {
    position: sticky;
    top: 0;
    z-index: 40;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
  .dark .chat-header { background-color: #1f2937; }
  
  /* No extra padding needed; header is sticky within the shell */
  .chat-layout { height: 100%; }
  
  /* Adjust messages padding on mobile */
  .chat-messages { padding-top: 56px; padding-bottom: 150px !important; }
  
  /* Fixed input for mobile */
  .chat-input-container {
    position: fixed !important; /* Override absolute positioning on mobile */
    left: 0;
    right: 0;
    bottom: 0;
  }
  
  /* Remove max-width constraint on content for mobile */
  .chat-content {
    max-width: 100%;
  }
  
  /* Ensure there are no background gradients on mobile */
  body, html, #root, .App, .flex-col {
    background: white !important;
    background-image: none !important;
    background-color: white !important;
  }

  .dark body, .dark html, .dark #root, .dark .App, .dark .flex-col {
    background: #343541 !important;
    background-image: none !important;
    background-color: #343541 !important;
  }
  
  .chat-sidebar {
    position: fixed;
    z-index: 40;
    top: calc(var(--topnav-height, 56px) + 56px);
    bottom: 0;
    width: 260px;
  }
  
  .sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 30;
  }
  
  /* Hide resize handle on mobile devices */
  .cursor-col-resize {
    display: none !important;
  }
  
  /* Ensure chat-content takes full width and has proper background */
  .chat-content {
    width: 100%;
    background-color: white !important;
  }
  
  .dark .chat-content {
    background-color: #1f2937 !important;
  }
  
  /* Override scrollbar styles for mobile */
  ::-webkit-scrollbar,
  *::-webkit-scrollbar {
    width: 0px !important;
    background-color: transparent !important;
  }
  
  ::-webkit-scrollbar-track,
  *::-webkit-scrollbar-track {
    background-color: transparent !important;
  }
  
  ::-webkit-scrollbar-thumb,
  *::-webkit-scrollbar-thumb {
    background-color: transparent !important;
  }
  
  /* Ensure body and html also have the correct background */
  body, html, #root {
    background-color: white !important;
  }
  
  .dark body, .dark html, .dark #root {
    background-color: #343541 !important;
  }
}
/* Chat header stays visible because only messages scroll */
.chat-header { position: relative; z-index: 40; }
`, "",{"version":3,"sources":["webpack://./src/styles/ChatLayout.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD,mEAAmE;AACnE;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa,EAAE,6DAA6D;EAC5E,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qEAAqE;AACrE;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kEAAkE;AAClE;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB,EAAE,0CAA0C;EAC7D,qBAAqB,EAAE,yBAAyB;EAChD,uBAAuB;EACvB,iCAAiC,EAAE,8BAA8B;EACjE,oGAAoG;AACtG;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iGAAiG;AACnG;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;EACd,uBAAuB;EACvB,8CAA8C;EAC9C,mDAAmD;EACnD,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iFAAiF;AACjF;EACE;IACE,8DAA8D;EAChE;AACF;;AAEA,oDAAoD;AACpD;EACE,8DAA8D;AAChE;;AAEA,2BAA2B;AAC3B;EACE,kCAAkC;EAClC;IACE,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,uBAAuB;IACvB,yCAAyC;EAC3C;EACA,qBAAqB,yBAAyB,EAAE;;EAEhD,+DAA+D;EAC/D,eAAe,YAAY,EAAE;;EAE7B,sCAAsC;EACtC,iBAAiB,iBAAiB,EAAE,gCAAgC,EAAE;;EAEtE,2BAA2B;EAC3B;IACE,0BAA0B,EAAE,4CAA4C;IACxE,OAAO;IACP,QAAQ;IACR,SAAS;EACX;;EAEA,sDAAsD;EACtD;IACE,eAAe;EACjB;;EAEA,uDAAuD;EACvD;IACE,4BAA4B;IAC5B,iCAAiC;IACjC,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;IACjC,oCAAoC;EACtC;;EAEA;IACE,eAAe;IACf,WAAW;IACX,4CAA4C;IAC5C,SAAS;IACT,YAAY;EACd;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,WAAW;EACb;;EAEA,yCAAyC;EACzC;IACE,wBAAwB;EAC1B;;EAEA,mEAAmE;EACnE;IACE,WAAW;IACX,kCAAkC;EACpC;;EAEA;IACE,oCAAoC;EACtC;;EAEA,yCAAyC;EACzC;;IAEE,qBAAqB;IACrB,wCAAwC;EAC1C;;EAEA;;IAEE,wCAAwC;EAC1C;;EAEA;;IAEE,wCAAwC;EAC1C;;EAEA,0DAA0D;EAC1D;IACE,kCAAkC;EACpC;;EAEA;IACE,oCAAoC;EACtC;AACF;AACA,2DAA2D;AAC3D,eAAe,kBAAkB,EAAE,WAAW,EAAE","sourcesContent":["/* ChatLayout.css - ChatGPT-style layout system */\n\n/* Global scrollbar reset to prevent other styles from overriding */\n*::-webkit-scrollbar-track {\n  all: unset;\n}\n\n.chat-layout {\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0; /* allow flex child to shrink and enable internal scrolling */\n  width: 100%;\n  overflow: hidden;\n  background-color: white;\n}\n\n.dark .chat-layout {\n  background-color: #1f2937;\n}\n\n/* Sidebar area */\n.chat-sidebar {\n  flex-shrink: 0;\n  height: 100%;\n  min-height: 100%;\n  border-right: 1px solid rgba(0, 0, 0, 0.1);\n  background-color: #F3F6FC;\n  transition: all 0.3s ease;\n  width: 260px;\n  overflow-y: auto;\n  z-index: 20;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Custom scrollbar for sidebar */\n.chat-sidebar::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.chat-sidebar::-webkit-scrollbar-track,\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: #F3F6FC !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n\n.chat-sidebar::-webkit-scrollbar-thumb {\n  background: rgba(115, 115, 115, 0.5);\n  border-radius: 3px;\n}\n\n.chat-sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(100, 100, 100, 0.7);\n}\n\n.chat-sidebar-hidden {\n  width: 0;\n  max-width: 0;\n  overflow: hidden;\n}\n\n.dark .chat-sidebar {\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  background-color: #202123;\n}\n\n.dark .chat-sidebar::-webkit-scrollbar-track,\n.dark .custom-scrollbar::-webkit-scrollbar-track {\n  background: #202123 !important;\n}\n\n.dark .chat-sidebar::-webkit-scrollbar-thumb {\n  background: rgba(217, 217, 227, 0.2);\n}\n\n.dark .chat-sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(217, 217, 227, 0.3);\n}\n\n/* Main content area - this is the container for messages AND input */\n.chat-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: relative;\n  background-color: white;\n  transition: all 0.3s ease;\n  max-width: calc(100% - 260px);\n  width: 100%;\n}\n\n.chat-sidebar-hidden + .chat-content {\n  max-width: 100%;\n}\n\n.dark .chat-content {\n  background-color: #343541;\n}\n\n/* Messages container - scrollable area between header and input */\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding-top: 56px; /* Reserve space for conversation header */\n  padding-bottom: 130px; /* Space for input area */\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch; /* Smoother scrolling on iOS */\n  background: linear-gradient(to bottom, transparent 0%, transparent 95%, rgba(255, 255, 255, 0) 100%);\n}\n\n/* Custom scrollbar for messages */\n.chat-messages::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.chat-messages::-webkit-scrollbar-track {\n  background: white;\n}\n\n.chat-messages::-webkit-scrollbar-thumb {\n  background: rgba(115, 115, 115, 0.5);\n  border-radius: 3px;\n}\n\n.chat-messages::-webkit-scrollbar-thumb:hover {\n  background: rgba(100, 100, 100, 0.7);\n}\n\n.dark .chat-messages {\n  background: linear-gradient(to bottom, transparent 0%, transparent 95%, rgba(31, 41, 55, 0) 100%);\n}\n\n.dark .chat-messages::-webkit-scrollbar-track {\n  background: #343541;\n}\n\n.dark .chat-messages::-webkit-scrollbar-thumb {\n  background: rgba(217, 217, 227, 0.2);\n}\n\n.dark .chat-messages::-webkit-scrollbar-thumb:hover {\n  background: rgba(217, 217, 227, 0.3);\n}\n\n/* Input area at bottom - always within chat-content */\n.chat-input-container {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 8px 0;\n  background-color: white;\n  padding-bottom: env(safe-area-inset-bottom, 0);\n  padding-bottom: constant(safe-area-inset-bottom, 0);\n  z-index: 10;\n}\n\n.dark .chat-input-container {\n  background-color: #343541;\n}\n\n/* For Android devices, add extra padding at the bottom when in mobile viewport */\n@supports (-webkit-touch-callout: none) {\n  .chat-input-container {\n    padding-bottom: calc(env(safe-area-inset-bottom, 16px) + 16px);\n  }\n}\n\n/* Specific Android system navigation bar handling */\n.android-nav-present .chat-input-container {\n  padding-bottom: calc(env(safe-area-inset-bottom, 16px) + 48px);\n}\n\n/* Mobile-specific styles */\n@media (max-width: 767px) {\n  /* Sticky chat header for mobile */\n  .chat-header {\n    position: sticky;\n    top: 0;\n    z-index: 40;\n    background-color: white;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  }\n  .dark .chat-header { background-color: #1f2937; }\n  \n  /* No extra padding needed; header is sticky within the shell */\n  .chat-layout { height: 100%; }\n  \n  /* Adjust messages padding on mobile */\n  .chat-messages { padding-top: 56px; padding-bottom: 150px !important; }\n  \n  /* Fixed input for mobile */\n  .chat-input-container {\n    position: fixed !important; /* Override absolute positioning on mobile */\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n  \n  /* Remove max-width constraint on content for mobile */\n  .chat-content {\n    max-width: 100%;\n  }\n  \n  /* Ensure there are no background gradients on mobile */\n  body, html, #root, .App, .flex-col {\n    background: white !important;\n    background-image: none !important;\n    background-color: white !important;\n  }\n\n  .dark body, .dark html, .dark #root, .dark .App, .dark .flex-col {\n    background: #343541 !important;\n    background-image: none !important;\n    background-color: #343541 !important;\n  }\n  \n  .chat-sidebar {\n    position: fixed;\n    z-index: 40;\n    top: calc(var(--topnav-height, 56px) + 56px);\n    bottom: 0;\n    width: 260px;\n  }\n  \n  .sidebar-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 30;\n  }\n  \n  /* Hide resize handle on mobile devices */\n  .cursor-col-resize {\n    display: none !important;\n  }\n  \n  /* Ensure chat-content takes full width and has proper background */\n  .chat-content {\n    width: 100%;\n    background-color: white !important;\n  }\n  \n  .dark .chat-content {\n    background-color: #1f2937 !important;\n  }\n  \n  /* Override scrollbar styles for mobile */\n  ::-webkit-scrollbar,\n  *::-webkit-scrollbar {\n    width: 0px !important;\n    background-color: transparent !important;\n  }\n  \n  ::-webkit-scrollbar-track,\n  *::-webkit-scrollbar-track {\n    background-color: transparent !important;\n  }\n  \n  ::-webkit-scrollbar-thumb,\n  *::-webkit-scrollbar-thumb {\n    background-color: transparent !important;\n  }\n  \n  /* Ensure body and html also have the correct background */\n  body, html, #root {\n    background-color: white !important;\n  }\n  \n  .dark body, .dark html, .dark #root {\n    background-color: #343541 !important;\n  }\n}\n/* Chat header stays visible because only messages scroll */\n.chat-header { position: relative; z-index: 40; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
